/**
 * Purpose: the selectors that don't depend on any other functions.
 */
import type { OfferReduxBaseState } from '../types/offerReduxBaseState';
import type { OfferType, paymentServicesTypes, Terms, TermsById } from '@makemydeal/dr-platform-types';
import { OFFER_ENCRYPTION_FIELDS, OFFER_TYPE } from '@makemydeal/dr-platform-types';
import { getOffer } from './offerNodeSelectors';
import { getTermsByIdPayments } from './offerSelectors';

export function getCddIncentives(state: OfferReduxBaseState): any[] {
    const incentives = state?.createDeal?.offer?.payment?.incentives?.incentiveDetail;
    return incentives && incentives.length ? incentives : [];
}

export function isDealSummaryDisplayed(state: OfferReduxBaseState): boolean {
    const currentRoute = state?.routing?.locationBeforeTransitions?.pathname;
    return currentRoute === 'summary';
}

export function getRoundedMonthlyPaymentFromOffer(state: OfferReduxBaseState): number | null {
    const monthlyPayment = state?.offer?.monthlyPayment;
    return monthlyPayment ? Math.round(monthlyPayment) : null;
}

export function getDaysToFirstPayment(state: OfferReduxBaseState): number | undefined {
    return state.payment.daysToFirstPayment;
}

export function getOfferId(state: OfferReduxBaseState): string | undefined {
    return getOffer(state).offerId;
}

export function isPaymentNotAvailable(state: OfferReduxBaseState): boolean {
    // If the user enters an incorrect zip code (state.payment.zipCode === state.payment.lastFailedZipCode),
    // we still want to show as payment is available and use lastSuccessfulZipCode
    return state.payment.error && state.payment.zipCode !== state.payment.lastFailedZipCode;
}

/**
 * Returns the commonConsumerId assocated to the offer, which implicitly means the buyer participate commonConsumerId
 */
export const getShopperCommonConsumerId = (state: OfferReduxBaseState): string => state.offer?.commonConsumerId;

export const getEncryptionPaymentData = (state: OfferReduxBaseState): string => {
    return getOffer(state)[OFFER_ENCRYPTION_FIELDS.PAYMENT] || '';
};

export const getEncryptionIncentivesData = (state: OfferReduxBaseState): string => {
    return getOffer(state)[OFFER_ENCRYPTION_FIELDS.INCENTIVES] || '';
};

/**
 * @deprecated This selector is deprecated, please use getEncryptionPaymentData instead.
 */
export const getExtraData = (state: OfferReduxBaseState): string => {
    return getEncryptionPaymentData(state);
};

export const getTaxItems = (state: OfferReduxBaseState): paymentServicesTypes.TaxItems | undefined => {
    return state?.taxItems;
};

export const getTermsIdByOffer = (state: OfferReduxBaseState, offerType: OfferType): string[] | undefined => {
    const offerTermsType = offerType === OFFER_TYPE.finance ? 'financeTerms' : 'leaseTerms';
    return getTerms(state)[offerTermsType];
};

export const getTerms = (state: OfferReduxBaseState): Terms => {
    return getOffer(state).terms;
};

export const getAllTerms = (state: OfferReduxBaseState): TermsById => {
    return getTermsByIdPayments(state.offer);
};
